import {
  getContractList,
  getZcyContractList,
  createOrUpdateContract,
  getContractDetail,
} from '../services';

export default {
  namespace: 'contractList',
  state: {
    contractData: {},
    zcyContractData: {},
  },
  effects: {
    * getContractList({ payload }, { call, put }) {
      const result = yield call(getContractList, payload);
      yield put({
        type: 'update',
        payload: {
          contractData: result,
        },
      });
    },
    * getZcyContractList({ payload }, { call, put }) {
      const res = yield call(getZcyContractList, payload);
      const { result } = res;
      yield put({
        type: 'update',
        payload: {
          zcyContractData: result,
        },
      });
      return res;
    },
    * setZcyContractData({ payload }, { put }) {
      yield put({
        type: 'update',
        payload: {
          zcyContractData: payload,
        },
      });
    },
    * createOrUpdateContract({ payload }, { call }) {
      const res = yield call(createOrUpdateContract, payload);
      return res;
    },
    * getContractDetail({ payload }, { call }) {
      const res = yield call(getContractDetail, payload);
      return res;
    },
  },
  reducers: {
    update(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
